<template>
  <div class="card">
    <transition name="slide-fade" mode="out-in">
      <div class="-mb-2 text-center text-xl font-bold" :key="value">
        <span v-if="type === 'normal'">{{
          value ? formatNormal(value) : "-"
        }}</span>

        <span v-if="type === 'cash' && value" :class="statusColor(value)">{{
          value >= 0 ? "+" : ""
        }}</span>
        <span v-if="type === 'cash' && value" :class="statusColor(value)">{{
          value | currency
        }}</span>
        <span v-if="type === 'cash' && !value" :class="statusColor(value)"
          >-</span
        >

        <span v-if="type === 'percentage'" :class="statusColor(value)">{{
          value ? formatPercentage(value) : "-"
        }}</span>

        <span v-if="type === 'percentage_nutral'">{{
          value ? formatPercentage(value, true) : "-"
        }}</span>
      </div>
    </transition>
    <div
      class="truncate py-1 text-xs font-medium text-ontick-steel-500 dark:text-gray-300 xl:text-sm"
    >
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: Number,
      default: undefined,
    },
    type: {
      type: String,
      default: "normal",
    },
    suffix: {
      type: String,
      required: "",
    },
  },
  methods: {
    formatNormal(value) {
      const formatted = Number.parseFloat(value).toLocaleString("pt-BR");
      return this.suffix ? `${formatted}${this.suffix}` : formatted;
    },
    formatPercentage(value, isNeutral = false) {
      const formatted = Number.parseFloat(value).toLocaleString("pt-BR") + "%";
      return isNeutral ? formatted : value >= 0 ? `+${formatted}` : formatted;
    },
    statusColor(value) {
      let color;

      if (!value) return "dark:text-gray-300 text-ontick-carbon-900";

      if (value < 0) {
        color = "dark:text-ontick-red-500 text-ontick-red-700";
      } else if (value == 0 || value == "-") {
        color = "dark:text-gray-300 text-ontick-carbon-900";
      } else {
        color = "dark:text-ontick-green-500 text-ontick-green-700 ";
      }
      return color;
    },
  },
};
</script>

<style></style>
